import { t } from '@lingui/core/macro'

export const validateCardNumber = (cardNumber: string): string | null => {
    if (!cardNumber.trim()) {
        return t`Номер карты не должен быть пустым`
    }

    if (/[^\d ]+/g.test(cardNumber)) {
        return t`Номер карты должен содержать только цифры`
    }

    const cleanNumber = cardNumber.replace(/\s/g, '')

    if (cleanNumber.length < 13 || cleanNumber.length > 19) {
        return t`Номер карты должен содержать от 13 до 19 цифр`
    }

    // Алгоритм Луна
    let sum = 0
    let alternate = false

    for (let i = cleanNumber.length - 1; i >= 0; i--) {
        let n = parseInt(cleanNumber.charAt(i), 10)

        if (alternate) {
            n *= 2

            if (n > 9) {
                n = (n % 10) + 1
            }
        }

        sum += n

        alternate = !alternate
    }

    return (sum % 10 === 0) ? null : t`Неверный номер карты`
}

export const validateExpiryDate = (expiryDate: string): string | null => {
    if (!/^\d{2}\/\d{2}$/.test(expiryDate)) {
        return t`Формат: MM/YY`
    }

    const [month] = expiryDate.split('/').map(Number)

    if (month < 1 || month > 12) {
        return t`Неверный месяц`
    }

    return null
}

export const validateCVV = (cvv: string): string | null => {
    if (!/^\d{3,4}$/.test(cvv)) {
        return t`CVV должен содержать 3 или 4 цифры`
    }

    return null
}

export const validateCardholderName = (name: string): string | null => {
    const cleanName = name.trim()

    if (cleanName.length < 3 || cleanName.length > 60) {
        return t`Имя должно содержать от 3 до 60 символов`
    }

    if (!/^[a-zA-Z]+ [a-zA-Z]+$/.test(name)) {
        return t`Имя должно содержать только латинские буквы и пробелы`
    }

    return null
}
